module.exports = __webpack_public_path__ + "img/image_testi_lender_1.4adb4918.png";